<template>
	<div id="bed-builder">
		<div v-if="wallbed && !cabinetBed" id="ww-builder-container" hidden>
			<div class="ww-builder-overlay"></div>
			<div id="ww-builder">
				<div class="ww-builder-body">
					<div id="big-bed-builder">
						<BedBuilder :data-failure="dataFailure"/>
					</div>
				</div>
			</div>
		</div>
		<QuickBuilder :data-failure="dataFailure"/>
	</div>
</template>

<script>
import BedBuilder from "./components/BedBuilder.vue";
import QuickBuilder from "./components/QuickBuilder.vue";
import {mapState} from 'vuex';
export default {
	name: 'app',
	components: {
		BedBuilder,
		QuickBuilder
	},
	data() {
		return {
			dataFailure: false
		};
	},
	mounted() {
		//if(this.$route.name != 'choose-size') this.$router.push({name:'choose-size'});
		const dataTransferElement = document.getElementById("bb-data-transfer");
		const slug = dataTransferElement.getAttribute('data-bed-slug');
		this.$store.commit('setSlug', slug);
		this.$store.commit('setProductId', dataTransferElement.getAttribute('data-product'));
		this.$store.commit('setDiscounts', dataTransferElement.getAttribute('data-use-discounts'));
		// get wordpress nonce
		this.$store.commit('setNonce', document.getElementById("ww-builder").getAttribute('data-nonce'));
		this.loadWallbedData(slug);
	},
	methods: {
		/**
		 * make api call to get all the data for the wallbed
		 * using the slug passed
		 * @param  {[type]} slug [description]
		 * @return {[type]}      [description]
		 */
		loadWallbedData(slug) {
			//eslint-disable-next-line
			axios.get(`${process.env.VUE_APP_API_URL}wallbed/${slug}`)
				.then(response => this.handleWallbedData(response.data))
				.catch(error => this.handleDataFailure(error));
		},
		/**
		 * save wallbed data in store.
		 * @param  {[type]} response [description]
		 * @return {[type]}          [description]
		 */
		handleWallbedData(response) {
			this.$store.commit('setWallbedData', response);
		},
		/**
		 * Unable to make connection. Show a message.
		 * @param  {[type]} response [description]
		 * @return {[type]}          [description]
		 */
		handleDataFailure(error) {
			//eslint-disable-next-line
			console.warn(error);
			this.dataFailure = true;
		}
	},
	watch: {
		/** watch route changes and save the current step to the store.
		 *  Focus management + step announcements live in BedBuilder.vue
		 *  because the bed-builder uses a home-rolled view switcher (EventBus)
		 *  rather than Vue Router, so $route doesn't actually change on nav. */
		//eslint-disable-next-line
		$route(to, from) {
			this.$store.commit('setCurrentStep', to.name);
		}
	},
	computed: {
		...mapState({
			wallbed: state => state.wallbed,
			cabinetBed: state => state.cabinetBed
		})
	},
}
</script>

<style>
@import "./assets/css/styles.min.css";
</style>
